import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Params, Router} from "@angular/router";
import {UnitsService} from "../units.service";
import {UnitModel} from "../../model/unit.model";

@Component({
    selector: 'app-unit-edit',
    templateUrl: './unit-edit.component.html',
    standalone: false
})
export class UnitEditComponent implements OnInit {
  item: UnitModel;

  constructor(
    private service: UnitsService,
    private router: Router,
    private route: ActivatedRoute,
  ) { }

  ngOnInit(): void {
    this.initPage();
  }

  initPage() {
    this.route.params.subscribe((params:Params) => {
      let id = params['id'] ? params['id'] : null;
      if (!id) {
        return this.router.navigate(['/data/device-type']);
      } else {
        if (id === 'new') {
          this.item = new UnitModel();
        } else {
          this.fetchItem(id);
        }
      }
    })
  }

  fetchItem(id) {
    this.service.getItem(id).subscribe((resp:any) => {
      if (resp.error) {
        this.service.notiService.open(resp.error);
        this.router.navigate(['/data/unit']);
      }
      if (resp && resp.id) {
        this.item = new UnitModel(resp);
      }
    })
  }

  saveItem() {
    this.service.saveItem(this.item).subscribe((resp:any) => {
      if (resp.error) {
        return this.service.notiService.open(resp.error);
      }
      this.service.notiService.open('Saved');
      this.router.navigate(['/data/unit']);
    })
  }

  onDeleteItemClick() {
    this.service.confirmAction("Biztos törlöd ezt a mértékegységet?").subscribe((isConfirm: boolean) => {
      if (isConfirm) {
        this.deleteItem();
      }
    })
  }

  deleteItem() {
    this.service.deleteItem(this.item.id).subscribe((resp:any) => {
      if (resp.error) {
        return this.service.notiService.open(resp.error);
      }
      this.service.notiService.open("Deleted");
      this.router.navigate(['/data/unit']);
    });
  }

}
